import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'app/hooks/redux-thunk';
import { fetchConsent } from 'app/store/actions/consent-thunks';
import { Col, Grid, GridWidth, Typography } from 'app/component-library-wave';
import { Button } from '@lyse-as/formds-react';
import { Partner } from 'app/utils/partner-utils';
import { useAppNavigation } from 'app/utils/navigation-utils';
import { navigationService } from 'app/service/navigation/navigation-service';
import { LYSE_GENERAL_MARKETING_CONSENT_URL } from 'app/pages/account/privacy-and-concents/privacy-and-concents';
import { hasCookieGraceTimeExpired } from 'app/utils/date-utils';
import { postponeConsentReminderPrompt } from 'app/store/actions/core-actions';
import { CONSENT_REMINDER_PROMPT_GRACE_TIME } from 'app/utils/cookies';
import styles from './consent-reminder-notification.module.scss';

export const ConsentReminderNotification = () => {
  const dispatch = useAppDispatch();
  const { consent } = useAppSelector((state) => state.consent);
  const { goToPath } = useAppNavigation();
  const partnerNumber = useAppSelector((state) => state.userContext.selectedCustomerLocation?.partnerNumber);
  const [showConsentReminder, setShowConsentReminder] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    if (!hasCookieGraceTimeExpired(CONSENT_REMINDER_PROMPT_GRACE_TIME)) {
      return;
    }

    if (!consent) {
      dispatch(fetchConsent());
      return;
    }
    if (consent.generalMarketingEmail || consent.generalMarketingSms) {
      return;
    }
    setShowConsentReminder(true);
  }, [consent]);

  const postpone = () => {
    dispatch(postponeConsentReminderPrompt);
    setShowConsentReminder(false);
  };

  const updateMarketingConsent = () => {
    dispatch(postponeConsentReminderPrompt);
    if (partnerNumber === Partner.NO_Lyse) {
      goToPath(LYSE_GENERAL_MARKETING_CONSENT_URL);
      return;
    }
    goToPath(navigationService.PAGES.generalMarketing.url);
  };

  if (!showConsentReminder) {
    return null;
  }

  return (
    <Grid width={GridWidth.WIDE}>
      <Col sm={2} md={6} lg={12}>
        <aside data-testid="reminder-notification" className={styles.container}>
          <Typography component="h2" variant="formds-lead" bold={true}>
            {t('features.reminderNotifications.headline')}
          </Typography>
          <Typography component="p" variant="formds-body">
            {t('features.reminderNotifications.paragraph')}
          </Typography>
          <div className={styles.buttonRow}>
            <Button variant="filled" scheme="primary" onClick={updateMarketingConsent}>
              {t('features.reminderNotifications.cta')}
            </Button>
            <Button variant="text" scheme="primary" onClick={postpone}>
              {t('features.reminderNotifications.postpone')}
            </Button>
          </div>
        </aside>
      </Col>
    </Grid>
  );
};
